import { Link } from 'react-router-dom';
import { Logo } from './ui/Logo';

export function Footer() {
  return (
    <footer className="border-t border-white/[0.06] py-10">
      <div className="mx-auto max-w-7xl px-4">
        <div className="flex flex-col items-center gap-5">
          <Logo size="sm" />

          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-2">
            <Link to="/privacy" className="text-sm text-muted-foreground transition-colors hover:text-foreground">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-muted-foreground transition-colors hover:text-foreground">
              Terms of Service
            </Link>
            <a
              href="mailto:support@moviemeapp.com"
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              Contact Us
            </a>
          </nav>

          <p className="text-center text-xs tracking-wide text-muted-foreground/70">
            © {new Date().getFullYear()} MovieMe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
